import { OnInit, Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { PracticeService } from "../../../services/practice.service";
import { AuthService } from "src/app/services/auth.service";
import { PdfService } from "src/app/services/pdf.service";

@Component({
  selector: "app-practice-region-preparation-dialog",
  templateUrl: "practice-region-preparation-dialog.component.html",
  styleUrls: ["./practice-region-preparation-dialog.component.css"],
})
export class PracticeRegionPreparationDialogComponent implements OnInit {
  loading: boolean;
  preparationHtml: string;
  procedureHtml: string;

  constructor(
    private practiceService: PracticeService,
    private notificationToastService: NotificationToastService,
    private authService: AuthService,
    private pdfService: PdfService,
    public dialogRef: MatDialogRef<PracticeRegionPreparationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: number[]
  ) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async printAndClose() {
    try {
      await this.practiceService
        .getPreparationReportPdf(this.data, this.authService.getCenterId())
        .then((response) => {
          if (response.ReportBase64) {
            this.pdfService.base64ToPdfPrint(response.ReportBase64);
          }
        })
        .catch((err) => {
          this.notificationToastService.error(
            JSON.stringify(err.error),
            "Preparaciones"
          );
        });
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Preparaciones"
      );
    }
  }

  async ngOnInit() {
    try {
      this.loading = true;
      const view = await this.practiceService.getPracticeRegionPreparationView(
        this.data
      );
      this.preparationHtml = view.Preparations;
      this.procedureHtml = view.Procedures;
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Preparaciones"
      );
    } finally {
      this.loading = false;
    }
  }
}
